export const shadows = {
  bottom: '0 3px 30px rgba(0, 0, 0, 0.08)',
  top: '0px 0px 40px rgba(0,0,0,0.1)',
  left: '10px 0px 30px rgb(0 0 0 / 8%)',
};
